import { Meteor } from 'meteor/meteor';
import rateLimit from '../../modules/rate-limit';

import {
  insert,
  update,
  copy,
  softDelete,
  restore,
  hardDelete,
  toggleSharedGraphic,
  toggleSharedPrivateGraphic
} from './server/graphic-methods-server';

Meteor.methods({
  'graphics.insert'(graphic, userId = this.userId) {
    return insert(graphic, userId);
  },
  'graphics.update'(graphic) {
    return update(graphic);
  },
  'graphics.copy'(graphicId) {
    return copy(graphicId, this.userId);
  },
  'graphics.softDelete'(graphicId) {
    softDelete(graphicId);
  },
  'graphics.restore'(graphicId) {
    restore(graphicId);
  },
  'graphics.hardDelete'(graphicId) {
    return hardDelete(graphicId);
  },
  'graphics.toggleShared'(graphicId, isShared) {
    toggleSharedGraphic(graphicId, isShared);
  },
  'graphics.toggleSharedPrivate'(graphicId, isShared) {
    toggleSharedPrivateGraphic(graphicId, isShared);
  }
});

rateLimit({
  methods: [
    'graphics.insert',
    'graphics.update',
    'graphics.copy',
    'graphics.softDelete',
    'graphics.restore',
    'graphics.hardDelete',
    'graphics.toggleShared',
    'graphics.toggleSharedPrivateGraphic'
  ],
  limit: 5,
  timeRange: 1000
});
